// extracted by mini-css-extract-plugin
module.exports = {"component":"spotlight-modal-component--1BmwF"};